import { ConfigProvider } from 'antd';
import locale from 'antd/es/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import updateLocale from 'dayjs/plugin/updateLocale';
import RootScreens from 'features/RootScreens';
import moment from 'moment';
import React, { useEffect } from 'react';
import 'react-multi-carousel/lib/styles.css';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingPage from 'services/UI/LoadingPage';
import UILoadingPageRef, { uiLoadingBasicRef } from 'services/UI/LoadingPage/UILoadingRef';
import store, { persistor } from 'store';
import { createGlobalStyle } from 'styled-components';
import NetworkDetect from 'widgets/NetworkDetect';
import OTPVerification, { OTPVerificationRef } from 'widgets/OTPVerification';
import RequestAdminPWCallback, { requestAdminPWCallbackRef } from 'widgets/RequestAdminLocalPW/Callback';
import useQRScannerClockIn from 'hooks/useQRScannerClockIn';
import { PersistGate } from 'redux-persist/integration/react';
import NotificationModal, { notificationModalRef } from 'components/NotificationModal';
import PermissionManager from 'widgets/PermissionVerify';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  weekStart: 1
});

moment.locale('en');
moment.updateLocale('en', {
  week: {
    dow: 1
  }
});


const AppLayout: React.FC = () => <RootScreens />;

const App: React.FC = () => {
  useEffect(() => {
    const handleKeyDown = () => {
      // Kiểm tra nếu mã phím là F12 (mã 123) hoặc ESC (mã 27) thì chặn sự kiện
      // if (event.keyCode === 123 || event.keyCode === 27) {
      //   event.preventDefault();
      //   return;
      // }
    };

    window.addEventListener('keydown', handleKeyDown, false);

    return () => {
      window.removeEventListener('keydown', handleKeyDown, false);
    };
  }, []);

  return (
    <>
      <ConfigProvider
        theme={{
          'token': {
            'colorPrimary': '#ff8890',
            'colorPrimaryBg': '#FFF1F6',
            'colorPrimaryActive': '#FF8890',
            'colorText': '#1D2129',
            'colorTextSecondary': '#767676',
            'colorBorder': '#86909C',
            'colorBorderSecondary': '#C9CDD4',
            'colorFill': '#E5E6EB',
            'colorFillSecondary': '#E5E5E5',
            'colorFillTertiary': '#F6F7FC',
            'colorBgLayout': '#E5E5E5',
            'colorBgSpotlight': '#1D2129',
            'colorBgMask': 'rgba(0, 0, 0, 0.2)',
            'colorTextBase': '#1d2129',
            'colorBgBase': '#ffffff',
            'colorWarning': '#ff7d00',
            'colorError': '#f53f3f',
            'colorInfo': '#6fabb6',
            'fontSize': 16,
            'sizeStep': 4,
            'borderRadius': 5,
            'borderRadiusXS': 2,
            'wireframe': false
          },
        }}
        locale={locale}
      >
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppLayoutWithQRScanner />
            <GlobalStyle />
            <LoadingPage />
            <UILoadingPageRef ref={uiLoadingBasicRef} />
            <OTPVerification ref={OTPVerificationRef} />
            <RequestAdminPWCallback v2 ref={requestAdminPWCallbackRef} />
            <NotificationModal ref={notificationModalRef} />
            <PermissionManager.Portal />
            <ToastContainer />
            <NetworkDetect />
          </PersistGate>
        </Provider>
      </ConfigProvider>
    </>
  );
};

const AppLayoutWithQRScanner: React.FC = () => {
  // useQRScannerClockIn({ autoStart: true });

  return <AppLayout />;
};

export default App;

const GlobalStyle = createGlobalStyle<any>`
:root {
  
}
`;